// ABOUTME: Comprobaciones automáticas de calidad de una foto generada, a partir de la orientación
// ABOUTME: de la cara en la selfie y en el resultado. Puro: recibe números, devuelve señales.
export interface QualityChecks {
  faceDetected: boolean;
  yawSelfie: number | null;
  yawResult: number | null;
  /** La cara del resultado gira más de 15° respecto a la selfie: el modelo la recreó. */
  yawDrift: boolean;
}

export function summarizeChecks(yawSelfie: number | null, yawResult: number | null): QualityChecks {
  const faceDetected = yawResult !== null;
  const yawDrift = yawSelfie !== null && yawResult !== null && Math.abs(yawSelfie - yawResult) > 15;
  return { faceDetected, yawSelfie, yawResult, yawDrift };
}
